import { useState } from 'react';
import { beforeAfterProjects } from '../../../mocks/projects';
import Lightbox from '../../../components/feature/Lightbox';

const BeforeAfterGallery = () => {
  const [lightbox, setLightbox] = useState<{ images: { src: string; alt: string; label?: string }[]; index: number; title: string } | null>(null);

  const openLightbox = (projectIndex: number, imageIndex: number) => {
    const project = beforeAfterProjects[projectIndex];
    setLightbox({
      title: project.location,
      index: imageIndex,
      images: [
        { src: project.beforeImage, alt: `Voor - ${project.location}`, label: 'Voor' },
        { src: project.afterImage, alt: `Na - ${project.location}`, label: 'Na' },
      ],
    });
  };

  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <span className="inline-block px-4 py-2 bg-gray-100 rounded-full text-xs font-medium text-gray-600 uppercase tracking-wider mb-6">
            Transformaties
          </span>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight" style={{ fontFamily: 'serif' }}>
            ZIE HET<br />
            VERSCHIL
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {beforeAfterProjects.map((project, projectIndex) => (
            <div
              key={project.id}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl hover:scale-[1.02] transition-all duration-300 cursor-pointer group"
            >
              <div className="grid grid-cols-2 divide-x divide-gray-200">
                {/* Voor */}
                <div
                  className="relative aspect-[3/4] overflow-hidden"
                  onClick={() => openLightbox(projectIndex, 0)}
                >
                  <div className="absolute top-4 left-4 z-10 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                    <span className="text-xs font-bold text-gray-900 uppercase tracking-wider">Voor</span>
                  </div>
                  <img
                    src={project.beforeImage}
                    alt={`Voor - ${project.location}`}
                    className="w-full h-full object-cover object-top grayscale group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/0 group-hover:bg-white/80 transition-all duration-300 opacity-0 group-hover:opacity-100">
                      <i className="ri-zoom-in-line text-gray-900 text-lg"></i>
                    </div>
                  </div>
                </div>

                {/* Na */}
                <div
                  className="relative aspect-[3/4] overflow-hidden"
                  onClick={() => openLightbox(projectIndex, 1)}
                >
                  <div className="absolute top-4 right-4 z-10 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                    <span className="text-xs font-bold text-gray-900 uppercase tracking-wider">Na</span>
                  </div>
                  <img
                    src={project.afterImage}
                    alt={`Na - ${project.location}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/0 group-hover:bg-white/80 transition-all duration-300 opacity-0 group-hover:opacity-100">
                      <i className="ri-zoom-in-line text-gray-900 text-lg"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-6 text-center">
                <p className="text-sm text-gray-600 font-medium">{project.location}</p>
                <p className="text-xs text-gray-400 mt-1">Klik om te vergroten</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {lightbox && (
        <Lightbox
          images={lightbox.images}
          initialIndex={lightbox.index}
          title={lightbox.title}
          onClose={() => setLightbox(null)}
        />
      )}
    </section>
  );
};

export default BeforeAfterGallery;
